import { get, isEmpty, isString } from "lodash";

let defaultState = {
	fetching: false,
	status: false,
	data: [],
	sortField: "id",
	sortOrder: "desc",
	list: [],
	item: {},
	serverError: [],
	end: true,
	total: 0,
	page: 1,
	action: false,
	searchParams: {}
}

export default function listReducer(state = {
	urllist: defaultState,
	account: defaultState,
	monkuser: defaultState,
	activity: defaultState,
	cronlog: defaultState,
	media: defaultState,
	contact: defaultState,
	programme: defaultState,
	subscriber: defaultState,
	mymonk: defaultState,
	monk: defaultState,
	dropinsession: defaultState,
	programmeplunge: defaultState,
	emailcontent: defaultState,
	errorcontent: defaultState,
	education: defaultState,
	devicedefault: defaultState,
	userapp: defaultState,
	firmware: defaultState,
	limit: isEmpty(window.localStorage.getItem('limit')) ? 20 : parseInt(window.localStorage.getItem('limit'))
}, action) {
	switch (action.type) {
		case "FETCH_LIST_PENDING": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					item: get(state[attribute], 'item', {}), //Setup here to prevent it from fetching all data for dropdowns
					action: action.meta.action,
					serverError: [],
					fetching: true
				}
			}
		}
		case "FETCH_LIST_REJECTED":
		case "CRUD_REJECTED":
		case "APPEND_REJECTED": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					serverError: get(action.payload.data, 'data', [])
				}
			}
		}
		case "FETCH_LIST_FULFILLED": {
			const { attribute, total } = action.meta;
			const status = get(action.payload, "data.status", 400);
			const list = get(action.payload, "data.data.list", []);
			return {
				...state,
				[attribute]: {
					...state[attribute],
					fetching: false,
					status,
					serverError: get(action.payload.data, 'data', []),
					data: get(action.payload, "data.data", []),
					list: isString(list) ? JSON.parse(list || '[]') : (list ? list : []),
					total: total || get(action.payload, "data.data.total", 0),
					end: (total || get(action.payload, "data.data.total", 0)) < state.limit ? true : false,
					item: get(state[attribute], 'item', {}) //Resetup here to prevent it from fetching all data for dropdowns
				}
			}
		}
		case "ITEMS_PER_PAGE": {
			window.localStorage.setItem('limit', action.payload);
			return {
				...state,
				limit: action.payload
			}
		}
		case "ITEMS_PAGE": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					page: action.payload
				}
			}
		}
		case "SET_SEARCH_PARAMS": {
			const { attribute } = action.meta;
			let searchParams = action.payload;
			["page", "sortField", "sortOrder", "limit"].forEach(item => {
				if (searchParams[item]) {
					delete searchParams[item];
				}
			})
			return {
				...state,
				[attribute]: {
					...state[attribute],
					searchParams
				}
			}
		}
		case "APPEND_PENDING": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					action: action.meta.action,
					fetching: true,
					status: false
				}
			}
		}
		case "APPEND_FULFILLED": {
			const { attribute } = action.meta;
			const data = get(action.payload, "data.data.list", []);
			const d = isString(data) ? JSON.parse(data || '[]') : (data ? data : []);
			return {
				...state,
				[attribute]: {
					...state[attribute],
					fetching: false,
					list: [
						...state[attribute].list,
						...d
					],
					end: d.length < state.limit ? true : false,
					status: get(action.payload, "data.status", 400)
				}
			}
		}
		case "CRUD_PENDING": {
			const { attribute, crud_action } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					action: crud_action,
					status: false,
					fetching: crud_action,
					serverError: []
				}
			}
		}
		case "CRUD_FULFILLED": {
			const { attribute, crud_action } = action.meta;
			let new_data = state[attribute].list ? state[attribute].list : [];
			let status = get(action.payload.data, 'status', 400);
			if (status === 200) {
				if (crud_action === "create") {
					if (get(action.payload, "data.data", false) !== false) {
						new_data = [
							get(action, 'payload.data.data', {}),
							...new_data
						];
					}
				}
				else if (crud_action === "delete" || crud_action === "restore") {
					let apiData = get(action.payload, 'data.data', {});
					let item = new_data.find(d => d.id === apiData.id);
					if (item) {
						item.deleted = crud_action === "delete" ? 1 : 0
					}
				}
				else if (crud_action === "hide") {
					let data = get(action.payload, "data.data", []);
					data.forEach(item => {
						new_data = new_data.filter(d => item.id !== d.id)
					})
				}
				else if (crud_action === "update") {
					let data = get(action.payload, "data.data", {});
					let index = new_data.findIndex(d => data.id === d.id);
					if (index >= 0) {
						new_data.splice(index, 1, data);
					}
				}
				return {
					...state,
					[attribute]: {
						...state[attribute],
						fetching: false,
						data: get(action.payload, "data.data", {}),
						status,
						action: crud_action,
						total: crud_action === "hide" ? state[attribute].total - 1 : state[attribute].total,
						list: [
							...new_data
						],
						serverError: [],
					}
				}
			}
			return {
				...state,
				[attribute]: {
					...state[attribute],
					status,
					fetching: false,
					serverError: get(action.payload.data, 'data', [])
				}
			};
		}
		case "LOAD_ITEM_PENDING": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					fetching: true,
					action: 'loading',
					item: {}
				}
			}
		}
		case "LOAD_ITEM_REJECTED": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					fetching: false,
					status: get(action.payload.data, 'status', 400),
				}
			}
		}
		case "LOAD_ITEM_FULFILLED": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					fetching: false,
					action: 'fetch',
					status: get(action.payload.data, 'status', 400),
					data: get(action.payload.data, 'data', {}),
					item: get(action.payload.data, 'data', {})
				}
			}
		}
		case "SETUP_ITEM": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					item: action.payload
				}
			}
		}
		case "RESET_ITEM": {
			const { attribute } = action.meta;
			return {
				...state,
				[attribute]: {
					...state[attribute],
					item: {},
					action: ""
				}
			}
		}
		default: {
			return state;
		}
	}
}